import PropTypes from 'prop-types'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { isPresent, noop } from 'utils'
import ColumnGroup from 'features/dashboard/table/config/ColumnGroup'
import NoneAnchor from 'components/NoneAnchor'

const ScrollablePresetSelector = ({
  presets = [],
  columns,
  onChange = noop,
}) => {
  const topMargin = 100
  const scrollContainerRef = useRef()
  const [scrollHeight, setScrollHeight] = useState(0)
  const [scrollTop, setScrollTop] = useState(0)
  const [offsetTop, setOffsetTop] = useState(0)
  const [visiblePreset, setVisiblePreset] = useState(null)
  const itemRefs = useRef({})

  const containerScrollHeight =
    scrollContainerRef.current && scrollContainerRef.current.scrollHeight
  const containerOffsetTop =
    scrollContainerRef.current && scrollContainerRef.current.offsetTop

  useLayoutEffect(() => {
    setScrollHeight(scrollContainerRef.current.scrollHeight)
  }, [containerScrollHeight])

  useLayoutEffect(() => {
    setOffsetTop(scrollContainerRef.current.offsetTop)
  }, [containerOffsetTop])

  useEffect(() => {
    const baseLine = scrollTop + offsetTop + topMargin
    const container = scrollContainerRef.current
    const isEnd =
      container &&
      container.offsetHeight + container.scrollTop >= container.scrollHeight
    if (isEnd) {
      setVisiblePreset(presets[presets.length - 1])
    } else {
      setVisiblePreset(
        presets.find((current, i, { [i + 1]: next }) => {
          const currentOffset = itemRefs?.current?.[current.name]?.offsetTop
          const nextOffset =
            itemRefs?.current?.[next?.name]?.offsetTop || Number.MAX_VALUE
          return currentOffset < baseLine && baseLine < nextOffset
        })
      )
    }
  }, [scrollHeight, scrollTop, offsetTop, presets])

  const scrollTo = preset => {
    const currentElement = itemRefs?.current?.[preset.name]
    if (isPresent(currentElement))
      currentElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      })
  }

  return (
    <>
      <div className="box_menurow">
        <ul className="list_menurow">
          {presets.map(preset => (
            <li
              key={preset.name}
              className={classNames({ on: preset === visiblePreset })}>
              <NoneAnchor
                className="link_menurow"
                onClick={() => scrollTo(preset)}>
                {preset.displayName}
              </NoneAnchor>
            </li>
          ))}
        </ul>
      </div>
      <div
        className="box_itemrow"
        ref={scrollContainerRef}
        onScroll={e => setScrollTop(e.target.scrollTop)}>
        {presets.map(preset => (
          <ColumnGroup
            key={preset.name}
            preset={preset}
            columns={columns}
            onChange={onChange}
            ref={element => {
              itemRefs.current[preset.name] = element
            }}
          />
        ))}
      </div>
    </>
  )
}

export default ScrollablePresetSelector

ScrollablePresetSelector.propTypes = {
  columns: PropTypes.array.isRequired,
  presets: PropTypes.array.isRequired,
  onChange: PropTypes.func,
}
